import { getFormFieldValue } from "core/form";

import { GUARANTEED_FUND_RATIO_REDUCTION } from "./constants";

export const getGuaranteedFundRatioReductionValue = (formName) => (state) =>
    getFormFieldValue(formName, GUARANTEED_FUND_RATIO_REDUCTION)(state);
